import { render, staticRenderFns } from "./ResponsiveVideo.vue?vue&type=template&id=5434841c&scoped=true&"
import script from "./ResponsiveVideo.vue?vue&type=script&lang=js&"
export * from "./ResponsiveVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434841c",
  null
  
)

export default component.exports